import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

import { startAutoRefresh, stopAutoRefresh, stopDelay } from '../Auth.actions'
import VerificationFormComponent from './VerificationForm'

const formName = 'verificationForm'

const stateToProps = ({ auth: { user, allConfirmed } }) => ({
  allConfirmed,
  initialValues: {
    email: user.emailConfirmation?.value || user.username,
    phone: user.phoneConfirmation?.value || user.phone,
  },
})

const dispatchToProps = {
  startAutoRefresh,
  stopAutoRefresh,
  stopDelay,
}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    form: formName,
    enableReinitialize: true,
  })(VerificationFormComponent)
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/VerificationForm/VerificationForm.container.js